export const emailRegexp = /^(([^<>()[\]\\+.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const phoneNumberRegexp = /^[+\-0-9\(\)]+$/g;
export const tinRegexp = /^[0-9]{1,8}$/g;
export const validUrlRegexp = /^(f|ht)tps?:\/\//i;
